import React, { Fragment } from 'react';
import _ from 'lodash-es';
import validate from 'validate.js';

import { TitleBar, Card, Layout, StatusMessage, TagsInputWithLabel } from '../components/library-components';
import { TextField } from '@quintype/em/components/text-field';
import { PasswordField } from '@quintype/em/components/password-field';
import { Button } from '@quintype/em/components/button';

import { getCurrentAccountUserDetails, getAcccountConfig, updateAcccountConfig } from '../api';
import { isUrl } from '../helpers/urlUtils';

import './account-config.scss';

class GeneralSettings extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showNotification: {
        isNotificationOpen: false,
        status: '',
        statusMessage: ''
      },
      account: {},
      superUser: false,
      initialAccount: {},
      editMode: false,
      inputProps: {
        placeholder: 'Enter domains to be whitelisted, like https://example.com'
      }
    };

    this.updateField = this.updateField.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onStatusCancelClick = this.onStatusCancelClick.bind(this);
    this.handleDomainChange = this.handleDomainChange.bind(this);
  }

  updateField (field, value) {
    const newAccountState = Object.assign({}, this.state.account, {
      [field]: value
    });
    this.setState({
      account: newAccountState,
      editMode: true
    });
  }

  updateStoryAttributesConfig (field, value) {
    const storyAttributesConfig = this.state.account['story_attributes_api_config'];
    storyAttributesConfig[field] = value === '' ? null : value;
    const newAccountState = Object.assign(this.state.account, {
      story_attributes_api_config: storyAttributesConfig
    });
    this.setState({
      account: newAccountState,
      editMode: true
    });
  }

  updateCustomTaxonomyApiConfig (field, value) {
    const customTaxonomyApiConfig = this.state.account['account_custom_attributes_api_config'];
    customTaxonomyApiConfig[field] = value === '' ? null : value;
    const newAccountState = Object.assign(this.state.account, {
      account_custom_attributes_api_config: customTaxonomyApiConfig
    });
    this.setState({
      account: newAccountState,
      editMode: true
    });
  }

  validateDomainUrls (domains) {
    return (domains.length > 0) && domains.every(domain => isUrl(domain));
  }

  handleDomainChange (whitelistedDomains) {
    const domains = _.uniq(whitelistedDomains.map(str => str.trim()));
    if (this.validateDomainUrls(domains) || _.isEmpty(domains)) {
      const accountSettings = Object.assign({}, this.state.account, { whitelisted_domains: domains });
      const errors = Object.assign({}, this.state.errors, { whitelisted_domains: null });
      this.setState({ account: accountSettings, errors: errors, editMode: true });
    } else {
      const errors = Object.assign({}, this.state.errors, { whitelisted_domains: 'Please enter a unique and valid domain url' });
      this.setState({ errors: errors });
    }
  }

  onSubmitClick () {
    const constraints = {
      name: { presence: { allowEmpty: false, message: 'Required' } },
      website_url: {
        presence: { allowEmpty: false, message: 'Required' },
        url: true
      },
      'story_attributes_api_config.url': {
        url: {
          allowLocal: true
        }
      }
    };

    const errors = validate(this.state.account, constraints);

    if (errors) {
      this.setState({ errors, editMode: true });
    } else {
      updateAcccountConfig(this.state.account).then(
        data => {
          this.setState({
            account: data.account,
            initialAccount: data.account,
            editMode: !this.state.editMode,
            error: '',
            isSaveDisabled: true,
            errors: {},
            showNotification: {
              isNotificationOpen: true,
              status: 'success',
              statusMessage: 'General settings saved Successfully!'
            }
          });
        },
        errors => {
          this.setState({
            showNotification: {
              isNotificationOpen: true,
              status: 'error',
              statusMessage: errors.account
            }
          });
        }
      );
    }
  }

  onCancelClick () {
    this.setState({
      account: this.state.initialAccount,
      editMode: false,
      errors: {}
    });
  }

  onStatusCancelClick () {
    this.setState({
      showNotification: {
        isNotificationOpen: false,
        status: '',
        statusMessage: ''
      }
    });
  }

  componentDidMount () {
    getAcccountConfig().then(data => {
      this.setState({ account: data.account, initialAccount: data.account });
    });
    getCurrentAccountUserDetails().then(data => {
      this.setState({
        superUser: data.superuser
      });
    });
  }

  render () {
    return (
      <div className='general-settings-page'>
        <Layout ref={fieldEditor1 => (this.fieldEditor1 = fieldEditor1)}>
          <TitleBar title='General' breadcrumbTitle='Home' breadcrumbPath='/' />
          <Card>
            <TextField
              value={_.get(this.state.account, ['name'])}
              label='Name'
              placeholder='Type name'
              hint='This will be used as display name of your property across accesstype platform.'
              onChange={value => this.updateField('name', value)}
              errorMessage={_.get(this.state.errors, ['name', '0'])}
              readOnly={!this.state.superUser}
            />

            <TextField
              value={_.get(this.state.account, ['platform_type'])}
              label='Platform'
              placeholder='Type your platform'
              readOnly
            />

            <TextField
              value={_.get(this.state.account, ['website_url'])}
              label='Property default URL'
              placeholder='https://example.com'
              onChange={value => this.updateField('website_url', value)}
              errorMessage={_.get(this.state.errors, ['website_url', '0'])}
              readOnly={!this.state.superUser}
            />

            { this.state.superUser &&
              <Fragment>
                <TextField
                  value={_.get(this.state.account, ['story_attributes_api_config', 'url'])}
                  label='Story attributes Endpoint'
                  placeholder='https://example.com/api/story/attributes'
                  onChange={value => this.updateStoryAttributesConfig('url', value)}
                  errorMessage={_.get(this.state.errors, ['story_attributes_api_config.url', '0'])}
                  readOnly={!this.state.superUser}
                />

                <TextField
                  value={_.get(this.state.account, ['account_custom_attributes_api_config', 'url'])}
                  label='Account Custom Taxonomy Endpoint'
                  placeholder='https://example.com/api/v1/accesstype/taxonomy'
                  onChange={value => this.updateCustomTaxonomyApiConfig('url', value)}
                  errorMessage={_.get(this.state.errors, ['account_custom_attributes_api_config.url', '0'])}
                  readOnly={!this.state.superUser}
                />

                <TagsInputWithLabel
                  label={'Whitelisted Domains'}
                  dataTest={'whitelisted_domains'}
                  value={_.get(this.state.account, 'whitelisted_domains', [])}
                  onChange={this.handleDomainChange}
                  inputProps={this.state.inputProps}
                  onlyUnique
                />

                <p className='error-msg'>{_.get(this.state.errors, ['whitelisted_domains'])}</p>
              </Fragment>
            }

            <div className='general-settings-page__button-group'>
              <Button
                id='general-setting-cancel'
                onClick={e => this.onCancelClick(e)}>
                  Cancel
              </Button>
              <Button
                id='general-setting-save'
                onClick={e => this.onSubmitClick(e)}
                disabled={!this.state.editMode || !this.state.superUser}
                type='primary'
              >
                Save
              </Button>
            </div>
          </Card>

          <Card title={'Authentication Keys'}>
            <PasswordField
              value={_.get(this.state.account, ['at_js_integration_key'])}
              label='Account key (Safe to be used on Client side)'
              readOnly
            />

            { this.state.superUser &&
                <Fragment>
                  <PasswordField
                    value={_.get(this.state.account, ['authentication_shared_secret_token'])}
                    label='User JWT secret token'
                    readOnly
                  />
                  <PasswordField
                    value={_.get(this.state.account, ['api_key'])}
                    label='API Authentication key (To be kept secured)'
                    readOnly
                  />
                </Fragment>
            }

          </Card>

          {this.state.showNotification.isNotificationOpen && (
            <StatusMessage
              statusMessage={this.state.showNotification.statusMessage}
              status={this.state.showNotification.status}
              onCancel={(e) => this.onStatusCancelClick(e)}
            />
          )}
        </Layout>
      </div>
    );
  }
}

export default GeneralSettings;
